const getInitialState = () => ({
  unreadQuestionsIdList: new Set(),
  isSecondaryPanelVisible: false,
  secondaryPanelContentType: null,
  isShowingSpeakers: true,
})

// eslint-disable-next-line import-x/no-default-export
export default ({ actionNames }) => {
  const initialState = getInitialState()

  return (state = initialState, action = undefined) => {
    switch (action.type) {
      case actionNames.INIT: {
        return {
          ...state,
          selectedSidebarTab: action.defaultSidebarTab,
        }
      }
      case actionNames.REALTIME_QUESTION_ADDED: {
        return {
          ...state,
          unreadQuestionsIdList: new Set([
            ...state.unreadQuestionsIdList,
            action.commentId,
          ]),
        }
      }
      case actionNames.TOGGLE_SECONDARY_PANEL: {
        const isSecondaryPanelVisible = !state.isSecondaryPanelVisible
        let { unreadQuestionsIdList } = state

        if (action.payload[0] === 'questions' && !isSecondaryPanelVisible) {
          unreadQuestionsIdList = new Set()
        }

        return {
          ...state,
          isSecondaryPanelVisible,
          secondaryPanelContentType: action.payload[0] || null,
          unreadQuestionsIdList,
        }
      }
      /**
       * Since this is a sub feature that is dispatching this action, we have to
       *  hardcode it since we can't get to it otherwise.
       */
      case 'INFO-PANEL-SPEAKERS:FETCH_SUCCESS': {
        const { speakers } = action

        return {
          ...state,
          isShowingSpeakers: !!speakers?.length,
        }
      }
      default:
        return state
    }
  }
}
